import { FelaCSS } from '../../components/fela/flowtypes';
import { IStylingProps } from '../../themes/types';
import { TColor } from '../../types';
import IconWrap from './icon-wrap';

interface IProps extends IStylingProps {
  id?: string;
  color?: TColor;
  width?: number;
  style?: FelaCSS;
}

interface IconTypes {
  iconColor: string;
  width: number;
  height: number;
}

/** @deprecated - use `Send` icon from aura design system */
const IconPaperplane = ({ id, color, width = 48, style, ...restProps }: IProps) => {
  const viewBoxWidth = 48;
  const viewBoxHeight = 44.5;

  const icon = ({ iconColor, width, height }: IconTypes) => (
    <svg
      id={id}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      width={`${width}px`}
      height={`${height}px`}>
      <path
        fill={iconColor}
        d="M30.2 37.6l-5.6-15L41.9 7.9 30.2 37.6zm-11.1-7.3l2.2-5.7.2.1 1.4 3.7-3.8 1.9zM37.6 6.8l-16.4 14-13.3-3.5L37.6 6.8zM48 2v-.6c0-.1-.1-.3-.1-.4V.9c-.1-.1-.1-.2-.2-.3h-.1-.1c-.1-.1-.2-.2-.3-.2 0 0-.1 0-.1-.1-.1-.1-.3-.1-.4-.2h-.5-.1c-.2 0-.3 0-.4.1L1.2 15.8c-.9.3-1.4 1.4-1.1 2.3.2.6.7 1 1.2 1.1l16.4 4.4-3.7 9.8c-.4.9.1 2 1 2.3.5.2 1 .2 1.5-.1l7.7-3.8 4.3 11.5c.3.7.9 1.2 1.7 1.2.7 0 1.4-.5 1.7-1.2l16-40.9v-.1s.1-.2.1-.3z"
      />
    </svg>
  );

  return (
    <IconWrap
      icon={icon}
      color={color}
      width={width}
      viewBoxWidth={viewBoxWidth}
      viewBoxHeight={viewBoxHeight}
      style={style}
      {...restProps}
    />
  );
};

export default IconPaperplane;
